<template>
  <div class="login-container">
    <div class="content">
<!--      <img class="leftImg" src="~@/assets/login/left.png" alt="">-->
      <div class="login-box-left"></div>
      <div class="login-logo-box">
        <div class="login-logo-bar">
            <div class="logo-logo">
                <div class="logo"></div>
            </div>
            <div class="logo-text">流程管理</div>
        </div>
      </div>
      <div class="login-box-right">
        <el-form class="login-form" autoComplete="on" :model="loginForm" :rules="loginRules" ref="loginForm"
                 label-position="left">
<!--          <h3 class="title">OpenAuth.Pro</h3>-->
<!--          <p class="tips">OpenAuth.Core企业版</p>-->
          <el-form-item prop="username">
<!--              suffix-icon="iconfont icon-yonghu_zhanghao_wode"-->
            <span class="blue-icon iconfont icon-yonghu_zhanghao_wode"></span>
            <el-input name="username" type="text"
                      v-model="loginForm.username" autoComplete="on" placeholder="请输入登录账号" />

          </el-form-item>
          <el-form-item prop="password">
            <span class="blue-icon" @click="showPwd"
                     :class="pwdType === 'password' ? 'icon iconfont icon-xianshi_chakan' : 'icon iconfont icon-yincang'"></span>
            <el-input name="password" :type="pwdType" @keyup.enter.native="handleLogin" v-model="loginForm.password"
                      autoComplete="on" placeholder="请输入密码"></el-input>
          </el-form-item>

          <el-form-item prop="tenantid">
            <span class="blue-icon icon iconfont icon-yonghuguanli"></span>
            <el-select v-model="tenant" placeholder="请选择" @change="tenantChange">
              <el-option v-for="item in tenants" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <div class="tips" v-if="isIdentityAuth">
            <router-link to="/oidcRedirect">
              <el-badge is-dot>接口服务器启用了Oauth认证，请点击这里登录</el-badge>
            </router-link>
          </div>
          <el-form-item v-else class="btn">
            <el-button class="login-btn" v-waves type="primary"
                       :loading="loading" @click.native.prevent="handleLogin">
              登 录
            </el-button>
          </el-form-item>
<!--          <p class="tips"> 默认System登录后，你可以无法无天</p>-->
<!--          <p class="tips">admin/admin登录后，会少一点权限，资源管理/分类管理的字段会少一点</p>-->
<!--          <p class="tips">test/test登录后，权限会更少,资源管理/分类管理的字段也更少</p>-->
        </el-form>
      </div>
    </div>

  </div>
</template>

<script>
  import waves from '@/directive/waves' // 水波纹指令
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  export default {
    name: 'login',
    directives: {
      waves
    },
    data() {
      const validateUsername = (rule, value, callback) => {
        if (value.length <= 0) {
          callback(new Error('用户名不能为空'))
        } else {
          callback()
        }
      }
      const validatePass = (rule, value, callback) => {
        if (value.length <= 0) {
          callback(new Error('密码不能为空'))
        } else {
          callback()
        }
      }
      return {
        tenant: '', //当前选择的租户
        tenants: [
        //     {
        //   value: 'default',
        //   label: '默认租户'
        // }, {
        //   value: 'handa',
        //   label: '瀚达水务'
        // }, {
        //   value: 'shwg',
        //   label: '外冈水厂'
        // },
          {
            value: 'cdxj',
            label: '成都新津'
        },
        //   {
        //     value: 'shhd',
        //     label: '黄渡水厂'
        // }
        ],
        loginForm: {
          username: 'admin',
          password: 'yysF_2021.#'
        },
        loginRules: {
          username: [{
            required: true,
            trigger: 'blur',
            validator: validateUsername
          }],
          password: [{
            required: true,
            trigger: 'blur',
            validator: validatePass
          }]
        },
        loading: false,
        pwdType: 'password'
      }
    },
    computed: {
      ...mapGetters([
        'isIdentityAuth',
        'tenantid'
      ])
    },
    methods: {
      ...mapActions([
        'setTenantId', //
      ]),

      tenantChange(e) {
        this.setTenantId(e)
      },
      showPwd() {
        if (this.pwdType === 'password') {
          this.pwdType = ''
        } else {
          this.pwdType = 'password'
        }
      },
      handleLogin() {
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            this.loading = true
            this.$store.dispatch('Login', this.loginForm).then(() => {
              this.loading = false
              this.$router.push({
                path: '/'
              })
            }).catch(() => {
              this.loading = false
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss">
  $bg:#2d3a4b;
  $light_gray:#eee;
  $color_balck: #333;

  /* reset element-ui css */
  .login-container {
    .el-input {
      display: inline-block;
      height: 47px;
      width: 82%;

      input {
        background: transparent;
        border: 0px;
        -webkit-appearance: none;
        border-radius: 0px;
        padding: 12px 5px 12px 15px;
        color: $color_balck;
        height: 47px;

        &:-webkit-autofill {
          transition: background-color 5000s ease-in-out 0s;
        }
      }
    }
    .el-select{
        display: inline-block;
        height: 47px;
        width: 82%;
        .el-input{
            width:100%;
        }
    }
    .login-btn{
        width: 100%;
        height: 40px;
        background: #2c55e9;
        border-radius: 30px;
        color: #fff;
        font-size: 16px;
        margin-top: 30px;
    }
    .el-form-item {
      margin-bottom: 35px;
      border-radius: 5px;
      color: #454545;

      .el-form-item__content {
        background: #fff;
        border-bottom: 1px solid #ccc;
      }

      &:last-child {
        padding-top: 20px;

        .el-form-item__content {
          border: none;
        }
      }

    }
    .el-form-item.btn .el-form-item__content {
          border: none;
    }
  }
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 1150px) {
    .leftImg {
      width: 450px !important;
    }
  }

  @media screen and (max-width: 1010px) {
    .leftImg {
      width: 380px !important;
    }
  }

  @media screen and (max-width: 940px) {
    .leftImg {
      display: block;
      width: 260px !important;
      margin: 0 auto !important;
    }
  }

  $dark_gray:#D1DFE8;

  .login-container {
    height: 100%;
  /*  background: url('~@/assets/login/bg.png') no-repeat;*/
    background-color: #EBEBEA;
  /*  background-position: 0 0;*/
  /*  background-size: 62% 100%;*/
    text-align: center;

  /*  &:before {*/
  /*    content: '';*/
  /*    display: inline-block;*/
  /*    height: 100%;*/
  /*    vertical-align: middle;*/
  /*  }*/

    .content {
      /*display: inline-block;*/
      /*vertical-align: middle;*/
        display: flex;
        justify-content: center;
        .login-box-left{
            width: 60%;
            min-height: 100vh;
            background: url('~@/assets/login/login-bg.png') 100% 100% no-repeat;
            background-size: cover;
        }
        .login-logo-box {
            position: absolute;
            left: 58%;
            top: 10%;
            width: 42%;
            z-index: 2;
            transform: translateX(0px);
            .login-logo-bar{
                height: 120px;
                background: url('~@/assets/login/login-logo-bar.png') 30% 100% no-repeat;
            }
            .logo-logo{
                position: absolute;
                left: 23%;
                top: 1%;
                .logo{
                    width: 80px;
                    height: 80px;
                    background: url('~@/assets/login/login-logo.png') 100% 100% no-repeat;
                    background-size: cover !important;
                }
            }
            .logo-text{
                font-size: 42px;
                color: #fff;
                font-weight: bold;
                letter-spacing: 3px;
                position: absolute;
                left: 300px;
                top: 19px;
            }
        }
        .login-box-right{
            width: 40%;
            background: #fff;
            position: relative;
            padding-top: 7%;
        }
      >img {
        width: 568px;
        margin-right: 150px;
        vertical-align: middle;
      }

      .login-form {
          max-width: 43%;
          margin: 120px auto 0;
        /*display: inline-block;*/
        /*width: 400px;*/
        /*vertical-align: middle;*/
          .blue-icon{
              color: #1465ce;
              font-size: 22px;
              margin-right: 8px;
          }
      }
    }

    .svg-container {
      color: $dark_gray;
      vertical-align: middle;
      width: 33px;
      display: inline-block;
      font-size: 22px;

      &_login {
        font-size: 31px;
      }
    }

    .title {
      font-size: 26px;
      font-weight: 400;
      color: #4452D5;
      margin: 0;
      text-align: left;
    }

    .tips {
      color: #959595;
      font-size: 14px;
      margin-top: 0;
      margin-bottom: 40px;
      text-align: left;
    }

    .show-pwd {
      position: absolute;
      right: 10px;
      top: 7px;
      font-size: 16px;
      color: $dark_gray;
      cursor: pointer;
      user-select: none;
      font-size: 24px;
    }
  }
</style>
